export default {"src":"/_next/static/media/sprinkles.4cda2849.svg","height":235,"width":270,"blurWidth":0,"blurHeight":0};